var t = function() {
  return null;
};
t.isSelectOptGroup = !0;
export {
  t as default
};
//# sourceMappingURL=OptGroup.mjs.map
